module.exports = __webpack_public_path__ + "static/media/placeholder.8cb68ce2.webp";